// reCAPTCHA callbacks (must be global)
var entryRecaptchaToken = '';
var claimRecaptchaToken = '';
function onRecaptchaEntry(token) {
  entryRecaptchaToken = token;
  var form = document.getElementById('form-entry');
  if (form) form.dispatchEvent(new Event('change', { bubbles: true }));
}
function onRecaptchaEntryExpired() {
  entryRecaptchaToken = '';
  var form = document.getElementById('form-entry');
  if (form) form.dispatchEvent(new Event('change', { bubbles: true }));
}
function onRecaptchaClaim(token) {
  claimRecaptchaToken = token;
  var form = document.getElementById('form-claim');
  if (form) form.dispatchEvent(new Event('change', { bubbles: true }));
}
function onRecaptchaClaimExpired() {
  claimRecaptchaToken = '';
  var form = document.getElementById('form-claim');
  if (form) form.dispatchEvent(new Event('change', { bubbles: true }));
}

(function () {
  'use strict';

  const PROXY_BASE = '/apps/umbrella';
  const strings = window.camdenStrings || {};

  // ========== KLAVIYO (SERVER-SIDE PROXY) ==========

  /**
   * Call the server-side Klaviyo proxy endpoint.
   * Everything happens in a single call: identify, subscribe, coupon generation,
   * email HTML construction (server-side), and event tracking.
   * Returns the generated discount code or null.
   */
  async function klaviyoProxy(email, firstName, lastName, mobile, eventName, prizeIdentifier, entryId, optIn) {
    try {
      var formData = new FormData();
      formData.append('email', email);
      formData.append('first_name', firstName);
      formData.append('last_name', lastName);
      formData.append('mobile', mobile || '');
      formData.append('event_name', eventName || '');
      formData.append('prize_identifier', prizeIdentifier || '');
      formData.append('entry_id', entryId || '');
      formData.append('opt_in', optIn ? '1' : '0');

      var res = await fetch(PROXY_BASE + '/klaviyo', {
        method: 'POST',
        body: formData,
      });
      var data = await res.json();
      if (data.error) {
        console.error('Klaviyo proxy error:', data.message);
        return null;
      }
      return data.discount_code || null;
    } catch (err) {
      console.error('Klaviyo proxy error:', err);
      return null;
    }
  }

  // Centralised win message helpers
  function winBody(dispatchDays, requiresSize) {
    var sizeText = requiresSize ? ' and select your preferred size' : '';
    return 'Please add your details below' + sizeText + '. Your prize will be dispatched within ' + dispatchDays + ' days.';
  }

  // Prize copy per prize identifier
  const PRIZE_COPY = {
    camden_brewery_tour__tasting: {
      subtitle: "YOU'VE WON A CAMDEN BREWERY TOUR AND TASTING FOR TWO",
      body: "YOU'RE OFF TO OUR CAMDEN BREWERY TO TAKE A LOOK ROUND OUR SHINY BREWHOUSE TO SEE HOW WE DO THINGS",
      important: "The important bits: We'll be in touch within 7 days to organise a convenient date for your tour. Both you and your guest must be over the age of 18.",
    },
    camden_beer_jacket: {
      subtitle: 'YOU\'VE WON A CAMDEN BEER JACKET',
      body: winBody(60, true),
    },
    lager_lover_long_sleeve_tee: {
      subtitle: 'YOU\'VE WON A LAGER LOVER LONG SLEEVE TEE',
      body: winBody(28, true),
    },
    arch_55_long_sleeve_tee: {
      subtitle: 'YOU\'VE WON AN ARCH 55 LONG SLEEVE TEE',
      body: winBody(28, true),
    },
    arch_55_tote_bag: {
      subtitle: 'YOU\'VE WON AN ARCH 55 TOTE BAG',
      body: winBody(28, false),
    },
    picnic_blanket: {
      subtitle: 'YOU\'VE WON A PICNIC BLANKET',
      body: winBody(28, false),
    },
    camden_jack_glass: {
      subtitle: 'YOU\'VE WON A CAMDEN JACK GLASS',
      body: winBody(90, false),
    },
  };

  // State
  let entryResult = null;
  let prizeInfo = null;
  let entryFirstName = '';
  let entryLastName = '';
  let entryEmail = '';
  let entryPrizeIdentifier = '';
  let entryOptIn = false;
  let entryMobile = '';

  // Elements
  const wrapper = document.querySelector('competition-wrapper');
  if (!wrapper) return;

  const stages = wrapper.querySelectorAll('.competition__stage');
  const trackerItems = wrapper.querySelectorAll('.competition__tracker-item');
  const spinner = document.querySelector('.competition-spinner');
  const entryIdEl = wrapper.querySelector('.competition__entry-id');
  const entryIdSpan = entryIdEl ? entryIdEl.querySelector('span') : null;
  const entryIdInlineEl = wrapper.querySelector('.competition__entry-id-inline');
  const entryIdInlineSpan = entryIdInlineEl ? entryIdInlineEl.querySelector('.js-entry-id-number') : null;
  const thanksEntryIdEl = wrapper.querySelector('.js-thanks-entry-id');

  // Forms
  const formEntry = document.getElementById('form-entry');
  const formClaim = document.getElementById('form-claim');

  // Error modal
  const errorModal = document.getElementById('CompetitionErrorModal');
  const errorTitle = errorModal ? errorModal.querySelector('.js-error-title') : null;
  const errorText = errorModal ? errorModal.querySelector('.js-error-text') : null;

  // Prize elements
  const prizeSubtitleEl = wrapper.querySelector('.js-prize-subtitle');
  const prizeBodyEl = wrapper.querySelector('.js-prize-body');
  const prizeImportantEl = wrapper.querySelector('.js-prize-important');
  const sizeField = document.getElementById('claim-size-field');
  const sizeSelect = document.getElementById('Claim-Size');
  const sizeLabel = document.getElementById('claim-size-label');
  const addressFields = wrapper.querySelector('.claim-address-fields');
  const sizeGuideTabs = document.querySelectorAll('[data-size-guide-tab]');

  function showSizeGuideTab(name) {
    sizeGuideTabs.forEach(function (tab) {
      var isActive = tab.dataset.sizeGuideTab === name;
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
      var panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = !isActive;
    });
  }

  sizeGuideTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      showSizeGuideTab(tab.dataset.sizeGuideTab);
    });
  });

  // Status elements
  const statusTitleEl = wrapper.querySelector('.js-status-title');
  const statusBodyEl = wrapper.querySelector('.js-status-body');
  const statusSecondaryEl = wrapper.querySelector('.js-status-secondary');

  // Discount code elements
  const discountCodeEl = wrapper.querySelector('.js-discount-code');
  const thanksDiscountCodeEl = wrapper.querySelector('.js-thanks-discount-code');

  // ========== ACTIVATION STATUS CHECK ==========

  (async function checkActivationStatus() {
    try {
      var res = await fetch(PROXY_BASE + '/');
      var data = await res.json();

      if (data.error && data.message) {
        var msg = data.message.toLowerCase();

        if (msg.includes('not started')) {
          showStatusPage(
            'TOO EARLY',
            'Oops! Looks like you are too early.',
            'Please come back on 1st April 2026 for your chance to win a Camden Fresh Prize.'
          );
        } else if (msg.includes('ended')) {
          showStatusPage(
            'PROMOTION CLOSED',
            "Time at the bar! Last orders were called on 1st October 2026 and you're a little too late for your chance to win a Camden Fresh Prize.",
            'Please look out for future promotions or why not buy yourself some Camden merch from our <a href="https://camdentownbrewery.com/" target="_blank">Webshop</a>?'
          );
        } else if (msg.includes('unavailable')) {
          showStatusPage(
            'COME BACK LATER',
            data.message,
            ''
          );
        }
      }
    } catch (err) {
      // Status check failed — show the form anyway
      console.error('Status check error:', err);
    }
    wrapper.classList.add('is-ready');
  })();

  function showStatusPage(title, body, secondary) {
    if (statusTitleEl) statusTitleEl.textContent = title;
    if (statusBodyEl) statusBodyEl.textContent = body;
    if (statusSecondaryEl) statusSecondaryEl.innerHTML = secondary;

    // Hide the tracker and animated arms, then show status stage
    var tracker = wrapper.querySelector('.competition__tracker');
    if (tracker) tracker.style.display = 'none';
    var pathTop = document.getElementById('competition-path-top');
    var pathBottom = document.getElementById('competition-path-bottom');
    if (pathTop) pathTop.style.display = 'none';
    if (pathBottom) pathBottom.style.display = 'none';

    stages.forEach(function (s) { s.classList.remove('active'); });
    var statusStage = document.getElementById('competition-status');
    if (statusStage) statusStage.classList.add('active');
  }

  // ========== UTILITIES ==========

  function goToStage(stageId, stepNumber) {
    stages.forEach(function (s) { s.classList.remove('active'); });
    var target = document.getElementById(stageId);
    if (target) target.classList.add('active');

    trackerItems.forEach(function (item) {
      var step = parseInt(item.dataset.step);
      item.classList.remove('active');
      if (step <= stepNumber) item.classList.add('active');
    });

    // Track current stage for animation positioning
    wrapper.setAttribute('data-stage', stageId);

    wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function hideAnimationPaths() {
    var topPath = document.getElementById('competition-path-top');
    var bottomPath = document.getElementById('competition-path-bottom');
    if (topPath) topPath.style.display = 'none';
    if (bottomPath) bottomPath.style.display = 'none';
  }

  function showSpinner() {
    if (spinner) spinner.classList.add('active');
  }

  function hideSpinner() {
    if (spinner) spinner.classList.remove('active');
  }

  function showError(title, message) {
    if (errorTitle) errorTitle.textContent = title;
    if (errorText) errorText.innerHTML = message;
    if (errorModal) {
      if (errorModal.show) {
        errorModal.show();
      } else {
        errorModal.setAttribute('open', '');
      }
    }
  }

  function enableSubmit(form) {
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = false;
  }

  function disableSubmit(form) {
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
  }

  function watchFormValidity(form, recaptchaTokenFn) {
    var check = function () {
      var inputs = form.querySelectorAll('input[required], select[required]');
      var allValid = true;
      inputs.forEach(function (input) {
        // Skip hidden required fields (e.g. address fields hidden for tour prizes)
        if (input.offsetParent === null) return;
        if (input.type === 'checkbox') {
          if (!input.checked) allValid = false;
        } else {
          if (input.value.trim() === '') allValid = false;
        }
      });
      if (recaptchaTokenFn && !recaptchaTokenFn()) allValid = false;
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = !allValid;
    };
    form.addEventListener('input', check);
    form.addEventListener('change', check);
  }

  /**
   * Strip non-numeric characters and cap at 11 digits.
   * Matches validateMobile() from the standard Umbrella templates.
   */
  function validateMobile(el) {
    var val = el.value.replace(/[^0-9]/g, '');
    if (val.length > 11) val = val.substring(0, 11);
    // Ensure "07" prefix is preserved
    if (val.length >= 1 && val[0] !== '0') val = '07';
    if (val.length >= 2 && val.substring(0, 2) !== '07') val = '07';
    el.value = val;
  }

  // Attach validateMobile to all mobile inputs
  ['Entry-Mobile', 'Entry-ConfirmMobile', 'Claim-Mobile'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('input', function () { validateMobile(el); });
  });

  /**
   * Client-side confirm field validation.
   * Shows a browser validation message when the confirm field doesn't match.
   */
  function setupConfirmValidation(sourceId, confirmId, message) {
    var source = document.getElementById(sourceId);
    var confirm = document.getElementById(confirmId);
    if (!source || !confirm) return;

    function validate() {
      if (confirm.value && confirm.value !== source.value) {
        confirm.setCustomValidity(message);
      } else {
        confirm.setCustomValidity('');
      }
    }
    source.addEventListener('input', validate);
    confirm.addEventListener('input', validate);
  }

  setupConfirmValidation('Entry-Email', 'Entry-ConfirmEmail', 'Email addresses do not match.');
  setupConfirmValidation('Entry-Mobile', 'Entry-ConfirmMobile', 'Mobile numbers do not match.');

  // ========== STEP 1: ENTRY FORM SUBMIT ==========

  if (formEntry) {
    watchFormValidity(formEntry, function () { return entryRecaptchaToken; });

    formEntry.addEventListener('submit', async function (e) {
      e.preventDefault();

      // Double-check confirm fields match before submitting
      var email = document.getElementById('Entry-Email').value.trim();
      var confirmEmail = document.getElementById('Entry-ConfirmEmail').value.trim();
      var mobile = document.getElementById('Entry-Mobile').value.trim();
      var confirmMobile = document.getElementById('Entry-ConfirmMobile').value.trim();

      if (email !== confirmEmail) {
        showError('OOPS!', 'Email addresses do not match. Please check and try again.');
        return;
      }
      if (mobile !== confirmMobile) {
        showError('OOPS!', 'Mobile numbers do not match. Please check and try again.');
        return;
      }

      disableSubmit(formEntry);
      showSpinner();

      var firstName = document.getElementById('Entry-FirstName').value.trim();
      var lastName = document.getElementById('Entry-LastName').value.trim();
      var code = document.getElementById('Entry-Code').value.trim();
      var optIn = document.getElementById('Entry-OptIn');
      var retailer = document.getElementById('Entry-Retailer').value;
      var lastPurchase = document.getElementById('Entry-LastPurchase').value;
      var whyPurchased = document.getElementById('Entry-WhyPurchased').value;

      var formData = new FormData();
      formData.append('entry.urn_id', code);
      formData.append('user.first_name', firstName);
      formData.append('user.last_name', lastName);
      formData.append('user_email', email);
      formData.append('confirm_user.email', confirmEmail);
      formData.append('user.mobile', mobile);
      formData.append('confirm_user.mobile', confirmMobile);
      formData.append('user.terms_and_conditions', '1');
      formData.append('custom0', retailer);
      formData.append('custom1', lastPurchase);
      formData.append('custom2', whyPurchased);
      if (optIn && optIn.checked) {
        formData.append('user.opt_in', '1');
      }

      try {
        var response = await fetch(PROXY_BASE + '/entry_submit', {
          method: 'POST',
          body: formData,
        });

        var result = await response.json();
        entryResult = result;

        var identifier = result.data ? result.data.identifier : null;

        switch (identifier) {
          case 'success':
            var prize = result.data.prize;
            var isWin = prize && prize.type === 'win';

            // Show entry ID
            if (result.data.entry_id) {
              if (entryIdSpan) {
                entryIdSpan.textContent = result.data.entry_id;
                entryIdEl.classList.remove('hidden');
              }
              if (entryIdInlineSpan) {
                entryIdInlineSpan.textContent = result.data.entry_id;
                entryIdInlineEl.classList.remove('hidden');
              }
              if (thanksEntryIdEl) {
                thanksEntryIdEl.textContent = result.data.entry_id;
              }
            }

            // Toggle win/lose content
            wrapper.querySelectorAll('.won-content').forEach(function (el) {
              el.style.display = isWin ? '' : 'none';
            });
            wrapper.querySelectorAll('.lost-content').forEach(function (el) {
              el.style.display = isWin ? 'none' : '';
            });

            // Show/hide claim tracker step
            var claimTracker = wrapper.querySelector('.competition__tracker-item[data-step="3"]');
            if (claimTracker) {
              claimTracker.style.display = isWin ? '' : 'none';
            }

            if (isWin) {
              var prizeIdentifier = prize.identifier || '';
              var copy = PRIZE_COPY[prizeIdentifier] || {};

              // Store for use in claim submit
              entryFirstName = firstName;
              entryLastName = lastName;
              entryEmail = email;
              entryPrizeIdentifier = prizeIdentifier;
              entryOptIn = optIn && optIn.checked;
              entryMobile = mobile;

              // Set prize-specific copy
              if (prizeSubtitleEl) prizeSubtitleEl.textContent = copy.subtitle || prize.title || '';
              if (prizeBodyEl) prizeBodyEl.textContent = copy.body || '';
              if (prizeImportantEl) {
                prizeImportantEl.textContent = copy.important || '';
                prizeImportantEl.style.display = copy.important ? '' : 'none';
              }

              // Pre-fill email and mobile in claim form
              var claimEmail = document.getElementById('Claim-Email');
              if (claimEmail) claimEmail.value = email;
              var claimMobile = document.getElementById('Claim-Mobile');
              if (claimMobile) claimMobile.value = mobile;

              // Fetch prize info for size requirements and claim form type
              await loadPrizeInfo(result.entry_token);

              // Enable claim form validation watching
              watchClaimForm();
            } else {
              // Lose path — single call: generate coupon + build email server-side + track event
              var loseOptIn = optIn && optIn.checked;
              try {
                var couponCode = await klaviyoProxy(
                  email, firstName, lastName, mobile,
                  'Camden Fresh Entry Lost', 'lost', result.data.entry_id || '', loseOptIn
                );
                if (couponCode) {
                  if (discountCodeEl) discountCodeEl.textContent = couponCode;
                } else if (discountCodeEl && result.data.discount_code) {
                  discountCodeEl.textContent = result.data.discount_code;
                }
              } catch (klaviyoErr) {
                console.error('Klaviyo lose-path error:', klaviyoErr);
              }
            }

            goToStage('competition-prize', 2);
            if (isWin) {
              // Re-trigger hand animations on claim page (win only)
              if (window.playCompetitionAnimations) window.playCompetitionAnimations();
            } else {
              hideAnimationPaths();
            }
            break;

          case 'validation_error':
          case 'form_validation':
            var errorMsg = result.message || '';
            if (result.data && result.data.messages) {
              var msgs = result.data.messages;
              errorMsg = Object.keys(msgs).map(function (k) { return msgs[k]; }).join(' ');
            }
            showError(
              strings.invalidCodeTitle || 'OOPS!',
              strings.invalidCodeInformation || 'Please check your code and try again.'
            );
            enableSubmit(formEntry);
            break;

          case 'user_entries_limit':
          case 'user_entries_limit_per_day':
          case 'user_entries_limit_per_week':
            showError(
              strings.limitTitle || 'LOOKS LIKE YOU\'VE ENTERED THIS WEEK',
              strings.limitInformation || 'Entries are limited to one per person per week. Come back another time to enter your code and try again.'
            );
            break;

          case 'activation_entries_limit':
            showError(
              strings.comeBackTitle || 'PROMOTION CLOSED',
              strings.comeBackInformation || 'The maximum number of entries has been reached.'
            );
            break;

          default:
            showError('Error', result.message || strings.genericError);
            enableSubmit(formEntry);
        }
      } catch (err) {
        console.error('Entry submit error:', err);
        showError('Error', strings.genericError);
        enableSubmit(formEntry);
      } finally {
        hideSpinner();
      }
    });
  }

  // ========== PRIZE INFO & SIZE LOADING ==========

  async function loadPrizeInfo(entryToken) {
    if (!entryToken) return;

    try {
      var res = await fetch(PROXY_BASE + '/prize_info?token=' + encodeURIComponent(entryToken));
      prizeInfo = await res.json();

      if (prizeInfo.error || !prizeInfo.data) return;

      var data = prizeInfo.data;

      // Hide address fields for tour prizes (claim_tour only needs email + mobile)
      if (data.claim_form === 'claim_tour' && addressFields) {
        addressFields.style.display = 'none';
        // Remove required from hidden address fields
        addressFields.querySelectorAll('[required]').forEach(function (el) {
          el.removeAttribute('required');
        });
      }

      if (data.requires_size && data.sizes && sizeField && sizeSelect) {
        sizeSelect.setAttribute('required', 'required');
        sizeSelect.name = data.size_field;

        sizeSelect.innerHTML = '<option value="">Preferred Size *</option>';
        var sizes = data.sizes;
        var sizeKeys = Object.keys(sizes);
        for (var i = 0; i < sizeKeys.length; i++) {
          var size = sizeKeys[i];
          var quantity = sizes[size];
          var option = document.createElement('option');
          if (quantity > 0) {
            option.value = size;
            option.textContent = size;
          } else {
            option.value = '';
            option.textContent = size + ' - Not Available';
            option.disabled = true;
          }
          sizeSelect.appendChild(option);
        }

        sizeField.classList.remove('hidden');
      }
    } catch (err) {
      console.error('Prize info error:', err);
    }
  }

  // ========== CLAIM FORM ==========

  function watchClaimForm() {
    if (!formClaim) return;
    watchFormValidity(formClaim, function () { return claimRecaptchaToken; });
  }

  if (formClaim) {
    formClaim.addEventListener('submit', async function (e) {
      e.preventDefault();
      disableSubmit(formClaim);
      showSpinner();

      var claimForm = (prizeInfo && prizeInfo.data) ? prizeInfo.data.claim_form : 'claim_generic';
      var entryToken = entryResult ? entryResult.entry_token : '';
      var isTour = claimForm === 'claim_tour';

      var claimData = new FormData();
      claimData.append('entry_token', entryToken);
      claimData.append('user_email', document.getElementById('Claim-Email').value.trim());
      claimData.append('user.mobile', document.getElementById('Claim-Mobile').value.trim());
      claimData.append('form_identifier', claimForm);
      claimData.append('user.terms_and_conditions', '1');

      // Add address fields (not needed for tour prizes)
      if (!isTour) {
        claimData.append('entry_address_line1', document.getElementById('Claim-Address1').value.trim());
        claimData.append('entry_address_line2', (document.getElementById('Claim-Address2') || {}).value || '');
        claimData.append('entry_address_city', document.getElementById('Claim-Town').value.trim());
        claimData.append('entry_address_county', document.getElementById('Claim-County').value.trim());
        claimData.append('entry_address_postcode', document.getElementById('Claim-Postcode').value.trim());
        claimData.append('entry_address_country', 'UK');
      }

      // Add size if required
      if (prizeInfo && prizeInfo.data && prizeInfo.data.requires_size && sizeSelect) {
        claimData.append(prizeInfo.data.size_field, sizeSelect.value);
      }

      try {
        var response = await fetch(PROXY_BASE + '/claim_submit', {
          method: 'POST',
          body: claimData,
        });

        var result = await response.json();
        var identifier = result.data ? result.data.identifier : null;

        switch (identifier) {
          case 'success':
            // Single call: generate coupon + build email server-side + track win event
            try {
              var couponCode = await klaviyoProxy(
                entryEmail, entryFirstName, entryLastName, entryMobile,
                'Camden Fresh Prize Won', entryPrizeIdentifier,
                (entryResult && entryResult.data) ? entryResult.data.entry_id : '', entryOptIn
              );
              if (couponCode) {
                if (thanksDiscountCodeEl) thanksDiscountCodeEl.textContent = couponCode;
              } else if (thanksDiscountCodeEl && result.data && result.data.discount_code) {
                thanksDiscountCodeEl.textContent = result.data.discount_code;
              }
            } catch (klaviyoErr) {
              console.error('Klaviyo win-path error:', klaviyoErr);
            }
            hideAnimationPaths();
            goToStage('competition-thanks', 3);
            break;

          case 'validation_error':
          case 'form_validation':
            var errorMsg = result.message || '';
            if (result.data && result.data.messages) {
              var msgs = result.data.messages;
              errorMsg = Object.keys(msgs).map(function (k) { return msgs[k]; }).join(' ');
            }
            showError('Error', errorMsg || 'Please check your details and try again.');
            enableSubmit(formClaim);
            break;

          default:
            showError('Error', result.message || strings.genericError);
            enableSubmit(formClaim);
        }
      } catch (err) {
        console.error('Claim submit error:', err);
        showError('Error', strings.genericError);
        enableSubmit(formClaim);
      } finally {
        hideSpinner();
      }
    });
  }
})();
